import { createSelector } from 'reselect'

const select = (state) => state.guide

const selectGuide = createSelector(select, (guide) => guide.guide)

const selectGuideFetching = createSelector(select, (guide) => guide.isFetching)

export { selectGuide, selectGuideFetching }
